import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-text-callout',
  templateUrl: './text-callout.component.html',
  styleUrls: ['./text-callout.component.scss']
})
export class TextCalloutComponent implements OnInit {
  @Input() text: string;
  @Input() small: boolean;

  constructor() { }

  ngOnInit() {
  }

}
